import './navigation.scss';
import { TweenMax } from "gsap/all";
import InViewportHelper from '../../helpers/in-viewport/in-viewport';

const NavigationComponent = {
  body: null,
  el: null,
  overlay: null,
  ref: null,
  subnavs: null,

  init() {
    // Set Element References
    this.body = document.querySelector('body');
    this.el = document.querySelector('#navigation');
    this.ref = document.querySelector('#navigation-reference');
    this.overlay = document.querySelector('#navigation-overlay');
    this.subnavs = document.querySelectorAll('.navigation__with-subnav');

    document.querySelector('#white-overlay').style.display = 'none';

    // Setup Click Events
    this.setupEvents();
  },

  setupEvents() {
    // Setup Open Trigger
    this.el
      .querySelectorAll('.event-trigger')[0]
      .addEventListener('click', this.revealNavigation.bind(this));

    // Setup Close Trigger
    this.el
      .querySelectorAll('.close-trigger')[0]
      .addEventListener('click', this.concealNavigation.bind(this));

    this.overlay
      .addEventListener('click', this.concealNavigation.bind(this));

    // Setup Subnavigation Events
    this.subnavs.forEach((navItem) => {
      navItem.addEventListener('click', (ev) => {
        this.openSubnav(navItem, ev);
      });
    });

    window.addEventListener('resize', this.handleResize.bind(this));
    window.addEventListener('scroll', this.handleScroll.bind(this));
  },

  openSubnav(navItem, ev) {
    let par = ev.target.parentNode.parentNode;
    if (par.classList.contains('navigation__subroot')) {
      return;
    }

    ev.preventDefault();

    if (window.outerWidth > 768) {
      this.ref.querySelectorAll('.navigation__subroot--open').forEach((item) => {
        if (item === navItem) { return; }
        item.classList.remove('navigation__subroot--open');
      });

      navItem.classList.toggle('navigation__subroot--open');

      // Remove all inline styles
      navItem.querySelectorAll('.navigation__subroot > .navigation__item').forEach((subnavItem) => {
        subnavItem.style = null;
      });

      // If we're open, let's animate the subnav items
      if (navItem.classList.contains('navigation__subroot--open')) {
        TweenMax.staggerTo(navItem.querySelectorAll('.navigation__subroot > .navigation__item'), .5, { alpha: 1 }, .075);
      }
    } else {
      this.openMobileSubnav(navItem, ev);
    }
  },

  openMobileSubnav(navItem, ev) {
    let subnav = navItem.querySelectorAll('.navigation__subroot');
    
    if (subnav) {
      let mobileSubnav = this.ref.querySelectorAll('.navigation__mobile-subnav')[0];
      let subnavDuplicate = subnav[0].cloneNode(true);
      let navRoot = this.ref.querySelectorAll('.navigation__root')[0];
      
      mobileSubnav.innerHTML = '';
      mobileSubnav.appendChild(subnavDuplicate);

      mobileSubnav
        .querySelectorAll('.navigation__go-back')
        .forEach((backBtn) => {
          backBtn.addEventListener('click', this.returnToMainMenu.bind(this));
        });

      TweenMax.to('.navigation__root', 0.25, { left: '-100%', alpha: 0 });
      TweenMax.to('.navigation__mobile-subnav', 0.25, { left: '5%', alpha: 1 });
    }
  },

  returnToMainMenu(ev) {
    TweenMax.to('.navigation__mobile-subnav', 0.25, { left: '100%', alpha: 0 });
    TweenMax.to('.navigation__root', 0.25, { left: '5%', alpha: 1 });
  },

  revealNavigation() {
    this.overlay.style.display = 'block';
    this.overlay.style.opacity = 0;
    TweenMax.to(this.overlay, .25, { alpha: .5 });
    this.body.classList.add('navigation--open');
    this.ref.classList.add('navigation--open');
    this.el.classList.add('navigation--open');
  },

  concealNavigation() {
    TweenMax.killAll();

    // Close all open subnavs
    this.ref.querySelectorAll('.navigation__subroot--open').forEach((item) => {
      item.classList.remove('.navigation__subroot--open');
    });

    // Remove the inline styles from all root navigation items.
    this.ref.querySelectorAll('.navigation__root > .navigation__item').forEach((item) => {
      item.style = null;
    });

    this.subnavs.forEach((navItem) => {
      navItem.classList.remove('navigation__subroot--open');
    });

    this.ref.querySelectorAll('.navigation__root')[0].style = null;
    this.ref.querySelectorAll('.navigation__mobile-subnav')[0].style = null;

    // Reset the navigation and overlay.
    this.body.classList.remove('navigation--open');
    this.el.classList.remove('navigation--open');
    this.ref.classList.remove('navigation--open');
    this.overlay.style.opacity = 0;
    this.overlay.style.display = 'none';
  },

  handleResize(ev) {
    let openSubnavs = this.ref.querySelectorAll('.navigation__subroot--open');

    if (window.outerWidth <= 768 && openSubnavs.length > 0) {
      openSubnavs.forEach((navItem) => {
        navItem.classList.remove('navigation__subroot--open');
      });
    }
  },

  handleScroll(ev) {
    if (this.body.classList.contains('navigation--open') && window.outerWidth >= 768) {
      let inView = InViewportHelper.check(this.el);
      let alphaValue = !inView ? 0 : .5;

      if (inView) {
        this.overlay.style.display = 'block';
      }
      TweenMax.to(this.overlay, .25, { alpha: alphaValue, onComplete: () => {
        if (!inView) {
          this.overlay.style.display = 'none'
        }
      }});
    }
  }
};

export default NavigationComponent;